<style scoped>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}
.required_err {
  color: rgba(255, 0, 0);
}

.br {
    color: rgba(109, 103, 164);
}

.rc_section {
    padding-top: 12px;
}

</style>

<template>
<div class="vif_ipv6_addrs">
    <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        sort-by="id"
        class="elevation-1"
        @dblclick:row="on_dbl_click"
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title><h2 class="br">IPv6 addresses</h2></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <ValidationObserver ref="observer" v-slot="{ invalid }"><v-card><v-form>
            <v-card-title>
              <span class="headline">IPv6 addresses</span>
            </v-card-title>

            <v-card-text>
              <v-container style="height: 520px; overflow-y: scroll;">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                        v-bind:readonly="true"
                        v-model="edited_item.id"
                        label="VIF ID"
                    ></v-text-field>

                    <v-text-field
                      v-bind:readonly="true"
                      v-model="edited_item.name"
                      label="VIF Name"
                    >
                    </v-text-field>

                    <v-text-field
                      v-bind:readonly="true"
                      v-model="edited_item.ll_addr"
                      label="Link Local address"
                    ></v-text-field>

                    <div class="rc_section">
                      <v-toolbar flat>
                          <v-toolbar-title>Global addresses</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-btn @click="glob_addr_add()">Add</v-btn>
                      </v-toolbar>
                      <v-data-table
                              :headers="global_addrs_hdrs"
                              :items="edited_item.glob_addrs"
                              sort-by="addr"
                              hide-default-footer
                              class="elevation-1">
                          <template v-slot:item.actions="{ item }">
                              <v-icon small @click="glob_addr_before_del(item)">
                                  mdi-delete
                              </v-icon>
                          </template>
                          <template v-slot:no-data>
                              No records
                          </template>
                      </v-data-table>
                    </div>

                    <div class="rc_section">
                      <v-toolbar flat>
                          <v-toolbar-title>Solicited-node multicast addresses</v-toolbar-title>
                          <v-spacer></v-spacer>
                      </v-toolbar>
                      <v-data-table
                              :headers="mcast_addrs_hdrs"
                              :items="edited_item.sol_nod_addrs"
                              sort-by="addr"
                              hide-default-footer
                              class="elevation-1">
                          <template v-slot:no-data>
                              No records
                          </template>
                      </v-data-table>
                    </div>

                    <div class="rc_section">
                      <v-toolbar flat>
                          <v-toolbar-title>Multicast addresses</v-toolbar-title>
                          <v-spacer></v-spacer>
                      </v-toolbar>
                      <v-data-table
                              :headers="mcast_addrs_hdrs"
                              :items="edited_item.maddrs"
                              sort-by="addr"
                              hide-default-footer
                              class="elevation-1">
                          <template v-slot:no-data>
                              No records
                          </template>
                      </v-data-table>
                    </div>                    
                </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Close</v-btn>
            </v-card-actions>
          </v-form></v-card></ValidationObserver>
        </v-dialog>

        <v-dialog v-model="ipv6_addr_dialog" max-width="500px">
          <ValidationObserver ref="ipv6_addr_observer" v-slot="{ invalid }"><v-card><v-form>
            <v-card-title>
                <span class="headline">Enter IPv6 address</span>
            </v-card-title>

            <v-card-text>
              <v-container style="height: 520px; overflow-y: scroll;">
                <v-row>
                    <v-col cols="12">
                        <ValidationProvider rules="required|ipv6_addr" v-slot="{ errors }">
                        <v-text-field
                            v-model="addr"
                            label="IPv6 address"
                        >
                        </v-text-field>
                        <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>          
                        <ValidationProvider rules="required|ipv6_mask" v-slot="{ errors }">
                        <v-text-field
                            v-model="addr_depth"
                            label="IPv6 mask"
                        >
                        </v-text-field>
                        <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>          
                    </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="ipv6_addr_add__cancel">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="ipv6_addr_add__ok">OK</v-btn>
            </v-card-actions>
          </v-form></v-card></ValidationObserver>
        </v-dialog>

      </v-toolbar>
      <v-toolbar flat>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="me-2"
        @click="edit_item(item)"
      >
        mdi-pencil
      </v-icon>
    </template>
    <template v-slot:no-data>
    </template>
    </v-data-table>
</div>
</template>
  
<script>
  import api_client from '../services/api.js';
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import { ValidationProvider, extend } from 'vee-validate';
  import { ValidationObserver } from 'vee-validate';
  import { required, numeric } from 'vee-validate/dist/rules';
  import "../validation_rules.js"

  export default {
    name: "vif_ipv6_addr",
    components: { Treeselect, ValidationProvider, ValidationObserver },
    data: () => ({
        search: '',
        dialog: false,
        ipv6_addr_dialog: false,
        headers: [
            { text: 'VIF Id', value: 'id', align: 'start' },
            { text: 'VIF Name', value: 'name' },
            { text: 'Port', value: 'port' },
            { text: 'SVID', value: 'svid' },
            { text: 'CVID', value: 'cvid' },
            { text: 'Encapsulation', value: 'encap' },
            { text: 'Local-link adress', value: 'll_addr' },
            { text: 'Local-link adress flags', value: 'll_flags' },
            { text: 'Global addresses', value: 'glob_addrs_s' },
            { text: 'Solicited-node addresses', value: 'sol_nod_addrs_s' },
            { text: 'Multicast addresses', value: 'maddrs_s' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],
        global_addrs_hdrs: [
            { text: 'Address', value: 'addr', align: 'start' },
            { text: 'Mask', value: 'depth' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],
        mcast_addrs_hdrs: [
            { text: 'Address', value: 'addr', align: 'start' },
        ],
        items: [],
        addr: '',
        addr_depth: 0,
        edited_index: -1,
        edited_item: { },
    }),

    created() {
        this.initialize()
    },

    methods: {
        calc_fields(i) {
          // global addresses
          i["glob_addrs_s"] = i.glob_addrs.map(j => j.addr + '/' + j.depth).join(', ');
          // solicited node addresses
          i["sol_nod_addrs_s"] = i.sol_nod_addrs.map(j => j.addr).join(', ');
          // multicast addresses
          i["maddrs_s"] = i.maddrs.map(j => j.addr).join(', ');
        },

        initialize() {
            api_client.run_get_query('/vif_ipv6_addr/show')
            .then(response => {
                this.items = response.data;
                this.items.forEach(this.calc_fields);
            })
            .catch(error => {
                console.log(error)
            })
        },

        edit_item(item) {
            this.edited_index = this.items.indexOf(item);
            this.edited_item = Object.assign({}, item);
            this.dialog = true;
        },

        on_dbl_click(event, data) {
            this.edit_item(data.item);
        },

        close() {
            this.dialog = false;
        },

        reload_item() {
            let data = { vif_name: this.edited_item.name };
            api_client.run_post_query('/vif_ipv6_addr/show_addr', data)
            .then(response => {
                let rec = Object.assign({}, response.data);
                this.calc_fields(rec);
                Object.assign(this.edited_item, rec);
                Object.assign(this.items[this.edited_index], rec);
            })
            .catch(error => {
                console.log(error)
            })
        },

        glob_addr_del() {
            api_client.run_post_query('/vif_ipv6_addr/del', {
                vif_name: this.edited_item.name,
                ip: this.addr,
                depth: this.addr_depth,
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.reload_item();
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        glob_addr_add() {
            this.addr = '';
            this.addr_depth = '';
            requestAnimationFrame(() => {
                this.$refs.ipv6_addr_observer.reset();
            });
            this.ipv6_addr_dialog = true;
        },

        ipv6_addr_add__ok() {
            api_client.run_post_query('/vif_ipv6_addr/add', {
                  vif_name: this.edited_item.name,
                  ip: this.addr,
                  depth: this.addr_depth,
              })
              .then(response => {
                  if (response.data.hasOwnProperty("err_msg")) {
                      this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                  }
                  else {
                      this.reload_item();
                      this.ipv6_addr_dialog = false;
                  }
              })
              .catch(error => {
                  console.log(error);
                  this.$fire({title: "Command failed", text: error, type: "warning"});
              });          
        },

        ipv6_addr_add__cancel() {
            this.ipv6_addr_dialog = false;
        },

        glob_addr_before_del(item) {
            this.addr = item.addr;
            this.addr_depth = item.depth;
            this.$confirm("Are you sure you want to delete IPv6 address " + this.addr + "/" + this.addr_depth + " ?")
            .then(() => {
                this.glob_addr_del();
            });
        },
    }
  };
  </script>
  